import React from "react";
import Card from "react-bootstrap/Card";
import profile from "../../images/default-img.jpg";
import PropTypes from "prop-types";

import "./candidateCard.scss";

const candidateCard = ({ message, userData }) => {
  return (
    <>
      <Card style={{ width: "13.125rem" }} className="card-custom">
        <Card.Img
          variant="top"
          src={userData.imageUrl ? userData.imageUrl : profile}
        />
        <Card.Body>
          <h6 className="text-primary">Hi! {userData.firstName}</h6>
          <p className="text-info">{message ? message : "Candidate"}</p>
        </Card.Body>
      </Card>
    </>
  );
};

candidateCard.prototype = {
  message: PropTypes.string,
  userData: PropTypes.object,
};

export default candidateCard;
